// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Gumshoe from 'gumshoejs/src/js/gumshoe/gumshoe';

export default class AnchorsList extends WebComponent {
	constructor(props) {
		super(props);
  }

	didMount() {
    const self = this;
    const {
      childSelector,
      clickSelector,
      sectionOffsetFromTop,
      offset,
      navClass,
      contentClass,
      fixedClass,
      fixedOnScroll,
    } = this.props;

    this.spy = new Gumshoe('.product-anchors a', {
      // Active classes
      navClass: navClass, // applied to the nav list item
      contentClass: contentClass, // applied to the content
      // Nested navigation
      nested: true, // if true, add classes to parents of active link
      nestedClass: 'active', // applied to the parent items
      // Offset & reflow
      offset: offset,
      reflow: false, // if true, listen for reflows
      // Event support
      events: true, // if true, emit custom events
    });

    if (AnchorsList.defaultProps.fixedOnScroll) {
      // Listen for activate events
      document.addEventListener('gumshoeActivate', function (event) {
        event.target.parentElement.classList.add(fixedClass);
      }, false);

      // Listen for activate events
      document.addEventListener('gumshoeDeactivate', function (event) {
        event.target.parentElement.classList.remove(fixedClass);
      }, false);
    }
	}

	willUnMount() {
    this.spy.destroy();
	}
}

AnchorsList.defaultProps = {
	//childSelector: 'li',
	//clickSelector: 'li a',
  //sectionOffsetFromTop: 40,
  offset: 10, // how far from the top of the page to activate a content area
  navClass: 'active',
  contentClass: 'content-active',
  fixedOnScroll: true,
  fixedClass: 'product-anchors--fixed',
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AnchorsList.js